import { apiClient } from "@/shared/api/client";

export interface SupplierCommissionDto {
    supplierId: string;
    supplierName: string;
    dailyCommissionType: string;
    dailyAmount: number;
    dailyApplyDate?: string;  // 백엔드에서 제공하는 경우
    weeklyCommissionType: string;
    weeklyAmount: number;
    weeklyApplyDate?: string;  // 백엔드에서 제공하는 경우
    weeklyPaybackUseYn?: string;  // 주정산 페이백 사용여부 (Y/N)
    weeklyPaybackAmount?: number;  // 주정산 페이백 금액 (건당)
    // 예정된 페이백 정보
    scheduledPaybackUseYn?: string;  // 예정된 페이백 사용여부 (Y/N)
    scheduledPaybackAmount?: number;  // 예정된 페이백 금액 (건당)
    scheduledPaybackApplyDate?: string;  // 예정된 페이백 적용일 (yyyy-MM-dd)
    startDate?: string;  // 시작일자
    endDate?: string;  // 종료일자
}

export interface SaveSupplierCommissionRequest {
    suppId: string;
    dailyCommissionType: string | null;
    dailyAmount: number | null;
    weeklyCommissionType: string | null;
    weeklyAmount: number | null;
    weeklyPaybackUseYn: string | null;  // 주정산 페이백 사용여부 (Y/N)
    weeklyPaybackAmount: number | null;  // 주정산 페이백 금액 (건당)
    startDate: string;
    endDate: string | null;
    userId: string;
}

export interface CommissionHistoryItem {
    applyDate: string;
    period: string;
    commissionType: string;
    amount: number;
    modifier: string;
}

/** 협력사 수수료 저장 응답 DTO */
export interface SaveSupplierCommissionResponse {
    suppId: string;
    applyStartDate: string; // yyyy-MM-dd 형식
    isImmediateApply: boolean; // 수요일에 설정한 경우 true
}

const BASE_PATH = '/api/v1/supplier-commissions';

export const supplierCommissionApi = {
    getAllSupplierCommissions: async (): Promise<SupplierCommissionDto[]> => {
        const response = await apiClient.get<SupplierCommissionDto[]>(BASE_PATH);
        return response.data;
    },

    saveSupplierCommission: async (request: SaveSupplierCommissionRequest): Promise<SaveSupplierCommissionResponse> => {
        const response = await apiClient.post<SaveSupplierCommissionResponse>(BASE_PATH, request);
        return response.data;
    },

    getCommissionHistory: async (suppId: string): Promise<CommissionHistoryItem[]> => {
        const response = await apiClient.get<CommissionHistoryItem[]>(
            `${BASE_PATH}/${suppId}/history`
        );
        return response.data;
    }
};
